export var breadcrumbItemClickHandler = function (fireEventComponent, item, event) {
    var specialKey = event &&
        event instanceof MouseEvent &&
        (event.button !== 0 || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
    var eventDetail = {
        text: item.text,
        href: item.href
    };
    if (!specialKey) {
        fireEventComponent.__fireEvent('follow', eventDetail, { nativeEvent: event });
    }
    fireEventComponent.__fireEvent('click', eventDetail, { nativeEvent: event });
};
//# sourceMappingURL=breadcrumb-item-click-handler.js.map